import { Component } from '@angular/core';
import { AlertController, NavParams, ViewController } from 'ionic-angular';

import { GestaoPcaService } from '../../../../providers/gestao-pca-service';
import { MateriaisService } from '../../../../providers/materiais-service';

@Component({
    selector: 'page-modal-pv-materiais',
    templateUrl: 'modal-pv-materiais.html'
})
export class ModalPreVisualizarMateriaisPage {
    titulo: any;
    isJurisdicionado: any;
    listaDados: any;
    listaDadosBaixa: any = [];
    listaDadosReincidencia: any = [];
    listaDadosOutros: any = [];
    dataGeracao: any;
    loading: boolean = true;
    shownGroup: any = [];

    listaAlienacoes: any = [];
    listaDoacoes: any = [];

    constructor(private viewCtrl: ViewController,
        public navParams: NavParams,
        public materiaisService: MateriaisService,
        public alertCtrl: AlertController,
        public gestaoPcaService: GestaoPcaService) {

        this.dataGeracao = new Date();

        this.listarDados();
    }

    dismiss() {
        this.viewCtrl.dismiss();
    }

    maiorQZero(valor){
        return valor >= 0;
    }
    
    listarDados() {
        this.materiaisService.obterPreviewCertificado().subscribe(
            data => {
                this.listaDados = data;

                this.listaAlienacoes = this.listaDados.analiseAlienacoesDoacoes.analises.filter(item1 => item1.decreto == "");
                this.listaDoacoes = this.listaDados.analiseAlienacoesDoacoes.analises.filter(item2 => item2.valorAlienacao == 0);
    
                this.loading = false;
            }, error => {
                console.log("erro: " + error);
                this.loading = false;
            }
        );
    }

    //  #region Métodos do Accordion
    toggleGroup(group) {
        if (this.isGroupShown(group)) {
            let index = this.shownGroup.indexOf(group);
            this.shownGroup.splice(index, 1);
        } else {
            this.shownGroup.push(group);
        }
    }

    isGroupShown(group) {
        return this.shownGroup.indexOf(group) != -1;
    };

    formatarValorNumerico(valor) {
        let valorFormatado = new Intl.NumberFormat('pt-BR',
            {
                style: 'currency',
                currency: 'BRL'
            }).format(valor);

        return valorFormatado.substr(2, valorFormatado.length).replace('$', '-');
    }

    formatarPorcentagem(valor) {
        return valor.toString().replace('.', ',') + "%";
    }

    somarAquisicoes(item) {
        let retorno = 0;

        if (item.valorAquisicoes) {
            if (item.valorContabil) {
                retorno = (item.valorContabil + item.valorAquisicoes);
            } else {
                retorno = item.valorAquisicoes;
            }
        } else if (item.valorContabil) {
            retorno = item.valorContabil;
        }

        return retorno;
    }

    calcularPorcentagem(item) {
        let retorno = 0;

        if (item.valorAquisicoes && item.valorContabil) {
            retorno = item.valorConsumo / (item.valorContabil + item.valorAquisicoes);
        }

        return retorno * 100;
    }
}



// WEBPACK FOOTER //
// ./src/pages/modais/modal-pre-visualizacao/materiais/modal-pv-materiais.ts